export default __webpack_public_path__ + "images/36_2_image.jpg";